import { NgModule, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { InternshipComponent } from './internship/internship.component';
import { CareersComponent } from './careers/careers.component';
const routes: Routes = [
{ path: 'internship', component: InternshipComponent },
{path:'careers', component:  CareersComponent},

];



@NgModule({
 
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]

})
export class CareersRoutingModule {
  


 }
